const constants = {
  APP_VERSION_LK: '-pv_i',
  COOKIE_ACCEPTED_LK: 'cookie:accepted',
  IS_LOGGED_USER_LK: '_lgd-i',
  USER_ID_LK: '_12lp',
  HOME_PAGE_ADDRESS_SK: 'hp-addr',
  LABELS_SK: 'labels'
};

const baseServices = {
  EXTERNAL_WASHING: 'External Washing',
  INTERNAL_WASHING: 'Internal Washing'
};

const enviroment =
  window.location.hostname == 'localhost'
    ? ''
    : process.env.NODE_ENV === 'development'
    ? '-dev'
    : '';

const isSameDay = (date1 = new Date(), date2 = new Date()) => {
  return new Date(date1).getDate() === new Date(date2).getDate();
};
const addHours = (hoursToAdd = 1, date = new Date()) => {
  const parsedDate = new Date(date);
  return new Date(parsedDate.setHours(parsedDate.getHours() + hoursToAdd));
};
const formatTimeInSlots = (from, to) => {
  return `${new Date(from).toLocaleTimeString(window.navigator.language, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  })} - ${new Date(to).toLocaleTimeString(window.navigator.language, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  })}`;
};
const formatTimeInDayPeriod = (from, to) => {
  return `${new Date(from).toLocaleTimeString(window.navigator.language, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  })} - ${new Date(to).toLocaleTimeString(window.navigator.language, {
    hour12: false,
    hour: '2-digit',
    minute: '2-digit'
  })}`;
};

const setHours = (date = new Date(), hours = 9) => {
  return new Date(date.setHours(hours));
};

const setMinutes = (date = new Date(), minutes = 0) => {
  return new Date(date.setMinutes(minutes));
};

const setSeconds = (date = new Date(), seconds = 0) => {
  return new Date(date.setSeconds(seconds));
};

const setMilliseconds = (date = new Date(), ms = 0) => {
  return new Date(date.setMilliseconds(ms));
};

const resetTime = (date = new Date()) => {
  return setMilliseconds(setSeconds(setMinutes(setHours(date, 9), 0), 0), 0);
};

const formatDateLong = (date = new Date()) => {
  return new Date(date).toLocaleDateString(window.navigator.language, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  });
};
const formatTime = (date = new Date()) => {
  return new Date(date).toLocaleTimeString(window.navigator.language, {
    hour: '2-digit',
    minute: '2-digit'
  });
};
const formatPrice = price => {
  return (price || 0).toFixed(2).replace('.', ',');
};

const getVehicleImgByCarId = (vehicleTypeName, size) => {
  if (vehicleTypeName?.toLowerCase() === 'scooter') {
    return `https://wo2-resources.s3.eu-west-3.amazonaws.com/vehiclesizes/scooter_default.svg`;
  }
  if (vehicleTypeName?.toLowerCase() === 'car') {
    return `https://wo2-resources.s3.eu-west-3.amazonaws.com/vehiclesizes/${size}.svg`;
  }
};

const getCarDefaultImg = () => {
  return `https://wo2-resources.s3.eu-west-3.amazonaws.com/vehiclesizes/Small.svg`;
};

const getScooterDefaultImg = () => {
  return `https://wo2-resources.s3.eu-west-3.amazonaws.com/vehiclesizes/scooter_default.svg`;
};

const getLocalizedURL = slug => {
  const lang = document.documentElement.lang || 'it';
  return lang == 'it'
    ? `/${slug}${enviroment}/`
    : `/${lang}/${lang}-${slug}${enviroment}/`;
};

const redirectToBookingFunnel = () => {
  window.location.href = getLocalizedURL('booking-funnel');
};

const redirectToWashingsHistory = () => {
  window.location.href = getLocalizedURL('washings-history');
};

const redirectToLogin = () => {
  window.location.href = getLocalizedURL('login');
};

const redirectToPersonalArea = () => {
  window.location.href = getLocalizedURL('personal-area');
};

const getTotalAmount = (services, baseServiceAmount) => {
  return (
    baseServiceAmount +
    services.reduce((acc, perf) => {
      return (acc += perf.amount);
    }, 0)
  );
};

const getLabel = (labels, labelKey) => {
  if (labels && typeof labels === 'object') {
    return (
      labels[Object.keys(labels).find(key => key === labelKey)] || labelKey
    );
  } else {
    return labelKey;
  }
};

const getLabelsBySection = (labels, section) => {
  return labelKey => getLabel(labels[section], labelKey);
};

/**
 * Try to get the label from a specific input key, or retrieve a default label
 *
 * @param {object} resources: the resources object
 * @param {string} labelKey: the key of the label
 * @param {string} rootKey: if the json resource object has a root to access the specific label { rootKey: { labelKey: 'VALUE' } }
 * @param {string} subKey: if the labelKey has a parent key before the root  { rootKey: { subKey: { labelKey: 'VALUE' } } }
 * @public
 */
function tryGetLabel(
  resources,
  labelKey,
  rootKey = undefined,
  subKey = undefined,
  showKey = false
) {
  if (showKey || !resources) {
    return 'LABEL_' + labelKey;
  }

  const root = rootKey
    ? subKey
      ? resources[rootKey][subKey]
      : resources[rootKey]
    : resources;

  return labelKey && root ? root[labelKey] : 'LABEL_' + labelKey;
}

/**
 * Utility to handle async function call inside a for cycle
 *
 * @param {object} array: the array to execute the for cycle
 * @param {function} callback: the callback of each function
 * @public
 */
async function asyncForEach(array, callback) {
  for (let i = 0; i < (array || []).length; i++) {
    await callback(array[i], i, array);
  }
}

/**
 * Utility to get the object value to pass to GTAG event "time_selected"
 *
 * @param {object} slot: the time slot object
 * @public
 */
function getGTAGtimeslotTrackingObject(slot) {
  switch (slot.id) {
    case 0:
      return { slot: 'fullday' };
    case 1:
      return { slot: 'morning' };
    case 2:
      return { slot: 'afternoon' };
    default:
      return { slot: 'custom range | ' + slot.formattedTime };
  }
}

/**
 * Replace all reference in a string
 * @param {string} origin: original string
 * @param {string} searchValue: value to replace
 * @param {string} newValue: new value
 * @public
 */
function replaceAll(origin, searchValue, newValue) {
  if (!origin || typeof origin != 'string') return origin;

  const searchValueRegex = new RegExp(searchValue, 'g');
  return origin.replace(searchValueRegex, newValue);
}

export {
  isSameDay,
  setHours,
  formatTimeInSlots,
  formatTimeInDayPeriod,
  resetTime,
  formatDateLong,
  formatTime,
  formatPrice,
  addHours,
  getVehicleImgByCarId,
  redirectToBookingFunnel,
  getTotalAmount,
  redirectToLogin,
  redirectToWashingsHistory,
  redirectToPersonalArea,
  getLabelsBySection,
  tryGetLabel,
  asyncForEach,
  constants,
  enviroment,
  getGTAGtimeslotTrackingObject,
  replaceAll,
  baseServices,
  getCarDefaultImg,
  getScooterDefaultImg
};
